import ErrorIcon from '@mui/icons-material/Error';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { InputAdornment, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import FormSelectController from 'commons/FormHook/FormSelectController';
import Text from 'commons/Text';
import { STATUS_CHOICES } from 'configs/Constant';
import useRole from 'hooks/useRole';

import EditArtworkLocation from '../EditArtworkLocation';
import useStyles from './styles';

const EditArtworkEditionItem = ({
  edition,
  index,
  control,
  statusOptions,
  locationOptions,
  onStatusChange,
  onOpenOwnerModal,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isArtist } = useRole();

  const isSold = edition?.status === STATUS_CHOICES.SOLD;
  const isDonatedGifted = edition?.status === STATUS_CHOICES.DONATED_GIFTED;
  const showOwnerSection = isSold || isDonatedGifted;

  return (
    <div>
      <Stack
        direction="row"
        spacing={2}
        className={classes.editionItemWrapper}
      >
        <div className={classes.statusNumberWidth}>{edition?.edition_number}</div>

        <Stack
          spacing={0.5}
          className={classes.statusWrapper}
        >
          <FormSelectController
            options={statusOptions}
            control={control}
            name={`editions.${index}.status`}
            valueKey="key"
            textDisplayKey="value"
            onChange={onStatusChange}
            disabled={!!edition?.id_certificate && !isArtist}
            IconComponent={edition?.id_certificate ? '' : KeyboardArrowDownIcon}
            endAdornment={
              edition?.id_certificate && (
                <InputAdornment position="end">
                  <Tooltip
                    title={t('this_edition_has_created')}
                    placement="top"
                    arrow
                  >
                    <ErrorIcon className={classes.errorIcon} />
                  </Tooltip>
                </InputAdornment>
              )
            }
            selectStyle={classes.selectDisable}
            formControlStyle={classes.formSelectControl}
          />
        </Stack>

        <EditArtworkLocation
          options={locationOptions}
          control={control}
          name={`editions.${index}.location`}
        />
      </Stack>
      <div style={{ display: 'flex' }}>
        <div className={classes.statusNumberWidth2} />
        {showOwnerSection && (
          <>
            {edition?.owner_name ? (
              <Text
                className={classes.textOwner}
                onClick={() => onOpenOwnerModal?.(index)}
                style={{ cursor: 'pointer' }}
              >
                {t('owner')}: {edition.owner_name}
                {edition?.price && (
                  <>
                    , {t('price')}: {Number(edition.price)}
                    {edition?.currency || 'VND'}
                  </>
                )}
              </Text>
            ) : (
              <Text
                className={classes.ownerHint}
                onClick={() => onOpenOwnerModal?.(index)}
                style={{ cursor: 'pointer' }}
              >
                {t('add_owner_name')}
              </Text>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EditArtworkEditionItem;
